// fontList.js
export const fontList = [
    // Web-safe fonts
    { value: "'Arial', sans-serif", label: "Arial" },
    { value: "'Times New Roman', serif", label: "Times New Roman" },
    { value: "'Courier New', monospace", label: "Courier New" },
    { value: "'Georgia', serif", label: "Georgia" },
    { value: "'Palatino Linotype', 'Book Antiqua', Palatino, serif", label: "Palatino Linotype" },
    { value: "'Tahoma', sans-serif", label: "Tahoma" },
    { value: "'Verdana', sans-serif", label: "Verdana" },
    { value: "'Impact', Charcoal, sans-serif", label: "Impact" },
    { value: "'Lucida Sans Unicode', 'Lucida Grande', sans-serif", label: "Lucida Sans Unicode" },
    { value: "'Tahoma', sans-serif", label: "Tahoma" },
    { value: "'Trebuchet MS', sans-serif", label: "Trebuchet MS" },
    { value: "'Arial Black', Gadget, sans-serif", label: "Arial Black" },
    { value: "'Times', serif", label: "Times" },
    { value: "'Lucida Console', Monaco, monospace", label: "Lucida Console" },
  
    // Common Google Fonts
    { value: "'Montserrat', sans-serif", label: "Montserrat" },
    { value: "'Roboto', sans-serif", label: "Roboto" },
    { value: "'Open Sans', sans-serif", label: "Open Sans" },
    { value: "'Lato', sans-serif", label: "Lato" },
    { value: "'Oswald', sans-serif", label: "Oswald" },
    { value: "'Source Sans Pro', sans-serif", label: "Source Sans Pro" },
    { value: "'Slabo 27px', serif", label: "Slabo 27px" },
    { value: "'Raleway', sans-serif", label: "Raleway" },
    { value: "'PT Sans', sans-serif", label: "PT Sans" },
    { value: "'Roboto Condensed', sans-serif", label: "Roboto Condensed" },
    { value: "'Poppins', sans-serif", label: "Poppins" },
    { value: "'Noto Sans', sans-serif", label: "Noto Sans" },
    { value: "'Ubuntu', sans-serif", label: "Ubuntu" },
    { value: "'Playfair Display', serif", label: "Playfair Display" },
    { value: "'Merriweather', serif", label: "Merriweather" },
    // ... more fonts can be added as needed
  ];
  